<template>
    <section class="bg-backgroundDark text-gold py-16 shadow-glow-gold">
        <div class="container mx-auto text-center px-6">
            <h1 class="text-4xl md:text-6xl font-bold mb-4">
                Deviens le N°1 de ta région
            </h1>
            <p class="text-lg md:text-xl text-backgroundLight max-w-2xl mx-auto mb-8">
                Paye pour grimper dans le classement et voir ton nom briller sur la carte de France.
            </p>
            <div class="flex justify-center gap-4 flex-wrap">
                <router-link :to="primaryCta.to" class="btn-gold">
                    {{ primaryCta.label }}
                </router-link>
                <router-link :to="secondaryCta.to" class="btn-secondary">
                    {{ secondaryCta.label }}
                </router-link>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/stores/authStore'

const authStore = useAuthStore()

const primaryCta = computed(() => {
    if (authStore.isLoggedIn) {
        return {
            label: 'Monter au classement',
            to: { name: 'BuyRanking' }
        }
    }

    return {
        label: 'Rejoins le classement',
        to: { name: 'LoginRegister', query: { view: 'register' } }
    }
})

const secondaryCta = computed(() => {
    if (authStore.isLoggedIn) {
        return {
            label: 'Voir mon classement',
            to: { name: 'UserRanking' }
        }
    }

    return {
        label: 'Calculateur de richesse',
        to: { name: 'WealthCalculator' }
    }
})
</script>
